import Swiper from "swiper/bundle";

const CaseStudyCards = () => {
  document.querySelectorAll(".xo2026-case-study-cards").forEach((block) => {
    const slider = block.querySelector(".xo2026-case-study-cards__slider");
    const previousButton = block.querySelector(".xo2026-case-study-cards__button--previous");
    const nextButton = block.querySelector(".xo2026-case-study-cards__button--next");

    if (!slider || Number(slider.dataset.cardsCount) <= 3) return;

    new Swiper(slider, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
          grid: {
            rows: 2,
            fill: "row",
          },
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 24,
          grid: {
            rows: 1,
          },
        },
        1441: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 32,
          grid: {
            rows: 1,
          },
        },
      },
    });
  });
};

export default CaseStudyCards;
